<!-- @format -->

<pickup-slider>
  <ul class="pickup_list slider">
    <li class="pickup_list-item" each="{ ad in props.featuredAds }">
      <h3 class="pickup_list-item-heading">
        <a href="/ad/detail/{ad.ad_id}">{ad.title}</a>
      </h3>
      <div class="container_pickup-info">
        <ul class="information_list">
          <li class="information_list-item">
            <span class="information_list-item-title">ジャンル・テーマ:</span>
            <span each={genre_name in ad.text_content_genres}>{genre_name}</span>
          </li>
        </ul>
        <!--/.information_list-->
        <ul class="information_list">
          <li class="information_list-item margin-spacing-2_right">
            <span class="information_list-item-title">制作物の数:</span>
            {ad.volume}{di.Edilent.cTypeProps(ad.text_content_type_group_ids).num}
          </li>
          <li class="information_list-item" if={!di.Edilent.isNonCharContentType(ad.text_content_type_group_ids)}>
            <span class="information_list-item-title">{di.Edilent.cTypeProps(ad.text_content_type_group_ids).title}:</span>
            <number-format number={ad.char_count_per_post} />{di.Edilent.cTypeProps(ad.text_content_type_group_ids).unit}
          </li>
        </ul>
        <!--/.information_list-->
        <ul class="information_list">
          <li class="information_list-item">
            <span class="information_list-item-title">想定報酬総額:</span>
            <span class="price">
              <number-format number={ad.project_sub_amount_min} />
              <span class="yen">円</span>
            </span>
            ~
            <span class="price">
              <number-format number={ad.project_sub_amount_max} />
              <span class="yen">円</span>
            </span>
          </li>
        </ul>
        <!--/.information_list-->
      </div>
      <!--/.container_pickup-info-->
      <div class="wrap_button">
        <button
          class="button button-secondary-mini"
          type="button"
          value="案件の詳細を見る"
          onclick="{e => props.detail(e, ad.ad_id)}"
        >
          案件の詳細を見る
        </button>
      </div>
      <!--/.wrap_button-->
    </li>
  </ul>

  <script>
    import di from "dependeny-injection";
    export default {
      di: di,
      state: {
        isLoaded: false,
      },
      onMounted(props, state) {
        this.onUpdated(props, state);
      },
      onUpdated(props, state) {
        if (this.state.isLoaded) {
          window.$(this.$(".slider")).slick("unslick");
        }
        window.$(this.$(".slider")).slick({
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        });
        this.state.isLoaded = true;
      },
      onBeforeUnmount() {
        window.$(this.$(".slider")).slick("unslick");
      },
    };
  </script>
</pickup-slider>
